import {
  SideNavigation,
  SideNavigationV2,
  useHasPermission,
} from 'portal-commons';
import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  faHome,
  faBullhorn,
  faCalendarDay,
  faGearCode,
  faGear,
} from '@fortawesome/pro-regular-svg-icons';

import { RCS_CAMPAIGN_ENABLED } from '../constants';
import {
  CSP_CAMPAIGNS_DEFAULT_ENTRY,
  DCA_CAMPAIGNS_DEFAULT_ENTRY,
  RCS_CSP_CAMPAIGNS_DEFAULT_ENTRY,
  RCS_DCA_CAMPAIGNS_DEFAULT_ENTRY,
} from '../constants/paths';
import { useAuthContext } from '../contexts';

const NavigationItems = RCS_CAMPAIGN_ENABLED
  ? [
      {
        title: 'Dashboard',
        icon: faHome,
        pathname: '/dashboard',
      },
      {
        title: 'CSP Campaigns',
        icon: faBullhorn,
        submenu: [
          {
            title: '10DLC',
            pathname: CSP_CAMPAIGNS_DEFAULT_ENTRY,
          },
          {
            title: 'RCS',
            pathname: RCS_CSP_CAMPAIGNS_DEFAULT_ENTRY,
          },
        ],
      },
      {
        title: 'DCA Campaigns',
        icon: faBullhorn,
        submenu: [
          {
            title: '10DLC',
            pathname: DCA_CAMPAIGNS_DEFAULT_ENTRY,
          },
          {
            title: 'RCS',
            pathname: RCS_DCA_CAMPAIGNS_DEFAULT_ENTRY,
          },
        ],
      },
      {
        title: 'Settings',
        icon: faGear,
        pathname: '/settings',
      },
      {
        title: 'Events',
        icon: faCalendarDay,
        pathname: '/events',
      },
    ]
  : [
      {
        title: 'Dashboard',
        icon: faHome,
        pathname: '/dashboard',
      },
      {
        title: '10DLC Campaigns Shared by CSPs',
        icon: faBullhorn,
        pathname: CSP_CAMPAIGNS_DEFAULT_ENTRY,
      },
      {
        title: '10DLC Campaigns Shared by Primary DCAs',
        icon: faBullhorn,
        pathname: DCA_CAMPAIGNS_DEFAULT_ENTRY,
      },
      {
        title: 'Settings',
        icon: faGear,
        pathname: '/settings',
      },
      {
        title: 'Events',
        icon: faCalendarDay,
        pathname: '/events',
      },
    ];

function PrimarySidebar(props) {
  const { authenticated } = props;
  const { user, role } = useAuthContext();
  const location = useLocation();
  const isIntegrationAccessible = useHasPermission('integrations.view');

  const navLink = useMemo(() => {
    return isIntegrationAccessible
      ? [
          ...NavigationItems,
          {
            title: 'Integrations',
            icon: faGearCode,
            pathname: '/integrations',
          },
        ]
      : NavigationItems;
  }, [role, isIntegrationAccessible]);

  return (
    <div className={`primary-side-menu ${authenticated ? '' : 'auth-page'}`}>
      {authenticated &&
        (RCS_CAMPAIGN_ENABLED ? (
          <SideNavigationV2
            portal="dca"
            items={navLink}
            location={location}
            lastLoginTime={user?.lastLogin}
            linkComponent={Link}
          />
        ) : (
          <SideNavigation
            portal="dca"
            items={navLink}
            location={location}
            lastLoginTime={user?.lastLogin}
            linkComponent={Link}
          />
        ))}
    </div>
  );
}

export default PrimarySidebar;
